/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumRichiestaDTOStatoOneri =
  (typeof EnumRichiestaDTOStatoOneri)[keyof typeof EnumRichiestaDTOStatoOneri];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumRichiestaDTOStatoOneri = {
  NESSUNO: 'NESSUNO',
  DA_PAGARE: 'DA_PAGARE',
  PAGATO: 'PAGATO',
  DA_PAGARE_FACOLTATIVO: 'DA_PAGARE_FACOLTATIVO',
} as const;
